// Copyright (c) 2018 Deere & Company

import React, {Component, PropTypes} from 'react';

/* eslint-disable react/prefer-stateless-function */

class PipCellRenderer extends Component {

    render() {

        return (
            <div className='pin-cell-renderer'>
                <a
                    className='product-pin-link'
                    href={`#/pips/programs/${encodeURI(this.props.data.pipNumber)}-${encodeURI(this.props.data.internalRecall)}?responsibleAccount=${encodeURI(this.props.data.responsibleAccount.account)}`}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    {this.props.value}
                </a>
            </div>
        );

    }

}

PipCellRenderer.displayName = 'PipCellRenderer';
PipCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
};

export default PipCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/pip-cell-renderer.js